import Stack from "@mui/material/Stack"

import TextInput from "@components/text_input"

import { useCustomerPageContext } from "@contexts/customer"
import { getCustomersOnboarding } from "@domain/customer/infos"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import styles from "./styles"

export default function CustomerCompanyPage() {
  const { translate, currentCustomer, resetCompany, controlCompany } =
    useCustomerPageContext()

  const { id } = useParams()
  const customer = currentCustomer

  async function handleGetCustomersOnboarding(id: string) {
    const { isSuccess, data } = await getCustomersOnboarding(id)
    if (!isSuccess) {
      return
    }
    const result = data?.data

    resetCompany?.({
      name: result?.companyName || "",
      website: result?.companyWebsite || "",
      role: result?.ownerRole || "",
      channel: result?.favouriteProducts || "",
      industry: result?.companyIndustry || "",
      size: result?.companySize || "",
      websiteBuild: result?.howBuiltWebsite || "",
      aboutUs: result?.howYouHearAboutUs || ""
    })
  }
  const customerId = customer?._id || id

  useEffect(() => {
    if (customerId) {
      handleGetCustomersOnboarding(customerId)
    }
  }, [customerId])

  return (
    <Stack sx={styles.containerWidth} gap={2} py={2}>
      <Stack gap={2}>
        <TextInput
          type="text"
          name="name"
          control={controlCompany}
          label={translate("company_name")}
          placeholder={translate("enter")}
          disabled
        />
        <TextInput
          type="url"
          name="website"
          control={controlCompany}
          label={translate("website")}
          placeholder={translate("enter")}
          disabled
        />
        <TextInput
          //type="select"
          name="role"
          control={controlCompany}
          label={translate("role")}
          placeholder={translate("enter")}
          disabled
        />
        <TextInput
          type="text"
          name="channel"
          control={controlCompany}
          label={translate("channel")}
          placeholder={translate("enter")}
          disabled
        />
        <TextInput
          type="text"
          name="industry"
          control={controlCompany}
          label={translate("industry")}
          placeholder={translate("enter")}
          disabled
        />
        <TextInput
          type="text"
          name="size"
          control={controlCompany}
          label={translate("size")}
          placeholder="1-20"
          disabled
        />
        <TextInput
          type="text"
          name="websiteBuild"
          control={controlCompany}
          label={translate("website_build")}
          placeholder="WordPress"
          disabled
        />
        <TextInput
          type="text"
          name="aboutUs"
          control={controlCompany}
          label={translate("about_us")}
          placeholder={translate("enter")}
          disabled
        />
      </Stack>
    </Stack>
  )
}
